import * as React from 'react';
import {FunctionComponent} from 'react';
import {Share} from '../../Components/Workout/Generic/Share';
import {FullWorkout, IndoorFullWorkout} from '../../../Models/FullWorkout';
import {IndoorIntervalTable} from '../../Components/Workout/Indoor/IndoorIntervalTable';
import {FullWorkoutSummary} from '../../Components/Workout/FullWorkoutSummary';
import {MachineConfigurationBadges} from '../../Components/Workout/Indoor/MachineConfigurationBadges';
import {WorkoutExecutionType} from '../../../Models/WorkoutExecutionType';
import {Loader} from '../../Components/Utils/Loader';
import {GeoTrackMap} from '../../Components/Workout/Outdoor/GeoTrackMap';
import {NetworkRequestStatusView} from '../../Components/Utils/NetworkRequestStatusView';
import {NetworkResult} from '../../../Network/NetworkResult';
import {GeoTrack} from '../../../Models/GeoTrack';

interface OwnProps {
    title: string;
    fullWorkout: FullWorkout;
    geoTrackDownloadResult?: NetworkResult<GeoTrack>;
}

export const Full: FunctionComponent<OwnProps> = ({title, fullWorkout, geoTrackDownloadResult}) => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <h1>{title}</h1>
                    {fullWorkout.execution_type === WorkoutExecutionType.INDOOR && (
                        <MachineConfigurationBadges
                            className="mb-3"
                            machineConfigurations={fullWorkout.machine_configurations}
                        />
                    )}
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-lg-9">
                    <FullWorkoutSummary fullWorkout={fullWorkout} />
                    {fullWorkout.execution_type === WorkoutExecutionType.INDOOR && (
                        <IndoorIntervalTable className="mt-3" indoorFullWorkout={fullWorkout as IndoorFullWorkout} />
                    )}
                    {fullWorkout.execution_type === WorkoutExecutionType.OUTDOOR && geoTrackDownloadResult && (
                        <NetworkRequestStatusView
                            result={geoTrackDownloadResult}
                            loader={() => <Loader className="mt-3" />}
                            error={() => null}
                            component={(geoTrack) => (
                                <div className="card mt-3">
                                    <div className="card-title">
                                        <h5>Map</h5>
                                    </div>
                                    <div className="card-bodygraphs">
                                        <div className="row">
                                            <div className="col-12">
                                                <GeoTrackMap height={400} geoTrack={geoTrack} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        />
                    )}
                </div>
                <div className="col-12 col-lg-3">
                    <Share className="mt-3 mt-lg-0" partialWorkout={fullWorkout} />
                </div>
            </div>
        </div>
    );
};
